<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   
      [device]="device" 
      [elementChoosing]="objectChoosing"  
      [width]="width" 
      [height]="height"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="container-font">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">
            
          </div>
          <div class="config-text" style="width: 100%">
            <!-- Nhập nội dung của nút -->
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('content');"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
            *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
              <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('aria_label', true)"></textarea>
            </mat-form-field>
          </div>
          <div class="config-font-size">
            <div class="field-row-font" style="width: 65%">
              <mat-form-field style="width: 100%">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="
                      class['btn-modal__boundary--content']['font-family']
                    " (ngModelChange)="updateClass()" [(value)]="class['btn-modal__boundary--content']['font-family']">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                    font.name
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field-row-size" style="width: 35%">
              <mat-form-field style="width: 100%">
                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                <input matInput type="number" [ngModel]="
                      class['btn-modal__boundary--content']['font-size'] | vhnumber
                    " (ngModelChange)="
                      class['btn-modal__boundary--content']['font-size'] =
                        $event + 'px'
                    " />
              </mat-form-field>
            </div>
          </div>
          <div class="config-font">
            <p class="title-font">{{'kieu_chu' | translate}}</p>
            <div class="field-row">
              <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                    class['btn-modal__boundary--content']['font-weight'] == 'bold'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['btn-modal__boundary--content']['font-weight'] =
                      class['btn-modal__boundary--content']['font-weight'] == 'bold'
                        ? '500'
                        : 'bold';
                    updateClass()
                  ">
                <span style="font-weight: 600">B</span>
              </button>
              <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                    class['btn-modal__boundary--content']['font-style'] == 'italic'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['btn-modal__boundary--content']['font-style'] =
                      class['btn-modal__boundary--content']['font-style'] == 'normal'
                        ? 'italic'
                        : 'normal';
                    updateClass()
                  ">
                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                    class['btn-modal__boundary--content']['text-decoration'] ==
                    'underline'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['btn-modal__boundary--content']['text-decoration'] =
                      class['btn-modal__boundary--content']['text-decoration'] ==
                      'none'
                        ? 'underline'
                        : 'none';
                    updateClass()
                  ">
                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                    class['btn-modal__boundary--content']['text-transform'] ==
                    'uppercase'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['btn-modal__boundary--content']['text-transform'] =
                      class['btn-modal__boundary--content']['text-transform'] ==
                      'none'
                        ? 'uppercase'
                        : 'none';
                    updateClass()
                  ">
                <span>AB</span>
              </button>
              <input class="input-color" style="width:23%;" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['btn-modal__boundary']['color']"
                [style.background]="class['btn-modal__boundary']['color']" (colorPickerClose)="updateClass()"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
            </div>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class['btn-modal__boundary--content']['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class['btn-modal__boundary--content']['letter-spacing'] =
                      $event + 'px'
                  "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                      class['btn-modal__boundary--content']['letter-spacing'] | vhnumber
                    " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                      class['btn-modal__boundary--content']['letter-spacing'] =
                        $event + 'px'
                    "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> {{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['btn-modal__boundary--content']['line-height']"
                (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
              [(ngModel)]="class['btn-modal__boundary--content']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
          <label class="px-1">{{'gian_cach' | translate}}</label>
          <div class="d-flex padding">
            <div class="d-flex">
              <img src="./assets/root/images/system/icons/padding-top.svg" alt="1" width="30px">
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%;"
                [ngModel]="class['btn-modal__boundary--content']['padding-top']| vhnumber"
                (nzBlur)="updateClassAndWidthHeight();updateDimension()"
                (ngModelChange)="class['btn-modal__boundary--content']['padding-top'] = $event + 'px'; class['btn-modal__boundary--content']['padding-bottom'] = $event + 'px'"></nz-input-number>
            </div>
            <div class="d-flex">
              <img src="./assets/root/images/system/icons/padding-right-left.svg" alt="1" width="30px">
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%;"
                [ngModel]="class['btn-modal__boundary--content']['padding-left'] | vhnumber "
                (nzBlur)="updateClassAndWidthHeight();updateDimension()"
                (ngModelChange)="class['btn-modal__boundary--content']['padding-right'] = $event + 'px'; class['btn-modal__boundary--content']['padding-left'] = $event + 'px'"></nz-input-number>
            </div>
          </div>
          <div class="font-adjusting">
            <div class="row-padding">
              <span class="title">{{'khoang_dem' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="40" [ngStyle]="{ width: '40%' }"
                [ngModel]="class['btn-modal__boundary--content']['padding'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="
                    class['btn-modal__boundary--content']['padding'] = $event + 'px'
                  "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="40" [ngModel]="
                      class['btn-modal__boundary--content']['padding'] | vhnumber
                    " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                      class['btn-modal__boundary--content']['padding'] = $event + 'px'
                    "></nz-slider>
          </div>
        </div>
      </li>
      <!-- Cấu hình màu nền của button -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
            [disabled]="config['background-color'].gradient_check"></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">{{'chon_mau' | translate}}</span>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-modal__boundary']['background-color']"
            [style.background]="class['btn-modal__boundary']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
        </div>
        <div class="mr-2 mb-4 mt-4 view-more" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 7px;
            ">
          <p class="discover_text" (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
        <!-- Mở popup so sánh màu tương phản -->
        <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
        nz-row (click)="openColorContrast()" nz-tooltip
        [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
        style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
          {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
        </button>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-symbol-config [device]="device" [class]="class" [config]="config"
          [symbolClass]="class['btn-modal__boundary']" [fontSizeIconClass]="class['btn-modal__boundary--icon']"
          [symbolConfig]="config['flex-direction']" [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-shadow-config [device]="device" [config]="config" [class]="class"
          [shadowClass]="class['btn-modal__boundary']" [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['btn-modal__boundary']"
          [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <li 
        *ngIf="objectChoosing.staticdata.id_freeblock"
        nz-submenu nzTitle="{{'cau_hinh_hop_thoai' | translate}}" 
        [(nzOpen)]="openMap.menu3" 
        (nzOpenChange)="openHandler('menu3')"
      >
        <!-- chon kieu hien thi hop thoai -->
        <div class="config-name">
          <p>{{'chon_kieu_hien_thi' | translate}}</p>
          <nz-select [(ngModel)]="config['type_show_block']" (ngModelChange)="updateConfig();">
            <nz-option nzValue="popup" nzLabel="{{'popup' | translate}}"></nz-option>
            <nz-option nzValue="drawer" nzLabel="{{'drawer' | translate}}"></nz-option>
          </nz-select>
        </div>
        <!-- CẤU HÌNH HỘP THOẠI POPUP -->
        <ng-container *ngIf="config['type_show_block'] == 'popup'">
          <div class="config-name">
            <p>{{'hien_thi_hop_thoai' | translate}}</p>
            <nz-switch [(ngModel)]="isOpen" (ngModelChange)="handleShowDialog($event)" ></nz-switch>
          </div>
          <!-- Đóng hộp thoại khi click ra ngoài -->
          <div class="config-name">
            <p>{{'dong_hop_thoai_khi_click_ra_ngoai' | translate}}</p>
            <nz-switch [(ngModel)]="config['is_close_on_click_outside']" 
              (ngModelChange)="updateConfig()"></nz-switch>
          </div>
          <!-- Canh lề hộp thoại -->
          <div class="config-font">
            <p class="title-font mt-3">{{'canh_le_hop_thoai' | translate}}</p>
            <div class="field-row">
              <button class="font-text-btn" style="width: 35px; flex: none" nz-button [nzType]="
                class['btn-modal__popup']['left'] == '0'
                  ? 'primary'
                  : 'default'" (click)="handlePositionPopup('right','left')">
                <i nz-icon nzType="align-left" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" style="width: 35px; flex: none" nz-button [nzType]="
                  class['btn-modal__popup']['left'] == '50%' && class['btn-modal__popup']['transform'] == 'translateX(-50%)'
                    ? 'primary'
                    : 'default'" (click)="handlePositionPopup('','center')">
                <i nz-icon nzType="align-center" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" style="width: 35px; flex: none" nz-button [nzType]="
                class['btn-modal__popup']['right'] == '0'
                  ? 'primary'
                  : 'default'" (click)="handlePositionPopup('left','right')">
                <i nz-icon nzType="align-right" nzTheme="outline"></i>
              </button>
            </div>
          </div>
          <!-- Vị trí trục dọc -->
          <div class="config-font">
            <p class="title-font mt-3">{{'vi_tri_truc_doc' | translate}}</p>
            <div class="field-row">
              <button class="font-text-btn" style="width: 35px; flex: none" nz-button 
              [nzType]="
                (class['btn-modal__popup']['top'] == '100%' && class['btn-modal__popup']['bottom'] == 'unset')
                  ? 'primary'
                  : 'default'
              " (click)="
                class['btn-modal__popup']['top'] = '100%';
                class['btn-modal__popup']['bottom'] = 'unset';
                class['btn-modal__popup']['margin-bottom'] = 0;
                updateClass()
              ">
                <i nz-icon nzType="vertical-align-bottom" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" style="width: 35px; flex: none" nz-button 
              [nzType]="
                (class['btn-modal__popup']['bottom'] == '100%' && class['btn-modal__popup']['top'] == 'unset')
                  ? 'primary'
                  : 'default'
                " (click)="
                  class['btn-modal__popup']['bottom'] = '100%';
                  class['btn-modal__popup']['top'] = 'unset';
                  class['btn-modal__popup']['margin-top'] = 0;
                  updateClass()
                ">
                <i nz-icon nzType="vertical-align-top" nzTheme="outline"></i>
              </button>
            </div>
          </div>
          <!-- Khoảng cách với nút -->
          <ng-container *ngIf="class['btn-modal__popup']['top'] == '100%' && class['btn-modal__popup']['bottom'] == 'unset'">
            <div class="config-name mb-0">
              <p>{{'khoang_cach_voi_nut' | translate}}</p>
              <nz-input-number [nzMin]="-100" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['btn-modal__popup']['margin-top'] | vhnumber"
                (ngModelChange)="class['btn-modal__popup']['margin-top'] = $event+'px'" (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <div>
              <nz-slider [nzMin]="-100" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['btn-modal__popup']['margin-top'] | vhnumber"
                (ngModelChange)="class['btn-modal__popup']['margin-top'] = $event+'px'" (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </ng-container>
          <!-- Khoảng cách với nút -->
          <ng-container *ngIf="class['btn-modal__popup']['bottom'] == '100%' && class['btn-modal__popup']['top'] == 'unset'">
            <div class="config-name mb-0">
              <p>{{'khoang_cach_voi_nut' | translate}}</p>
              <nz-input-number [nzMin]="-100" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['btn-modal__popup']['margin-bottom'] | vhnumber"
                (ngModelChange)="class['btn-modal__popup']['margin-bottom'] = $event+'px'" (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <div>
              <nz-slider [nzMin]="-100" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['btn-modal__popup']['margin-bottom'] | vhnumber"
                (ngModelChange)="class['btn-modal__popup']['margin-bottom'] = $event+'px'" (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </ng-container>
        </ng-container>
        <!-- CẤU HÌNH HỘP THOẠI DRAWER  -->
        <ng-container *ngIf="config['type_show_block'] == 'drawer'" >
          <div class="editor-field">
            <button class="open-drawer mb-2" nz-button nzType="default" (click)="handleShowDialog(true)">{{'mo_hop_thoai' | translate}}</button>

            <!-- Đóng hộp thoại khi chuyển trang -->
            <div class="config-name mt-0">
              <p>{{'khong_dong_hop_thoai_khi_chuyen_trang' | translate}}</p>
              <nz-switch [(ngModel)]="staticdata.no_close_modal_when_change_page" (ngModelChange)="updateStaticData()" ></nz-switch>
            </div>

            <!-- Hướng xuất hiện -->
            <div class="mt-4">
              <p>{{'huong_xuat_hien' | translate}}</p>
              <div class="config-position">
                <button 
                  nz-button
                  class="config-position__btn" 
                  [nzType]="config['block_position'] == 'top'? 'primary': 'default'" 
                  (click)="handlePositionDrawer('top')"
                >
                  <span class="config-position__btn--content">Trên</span>
                </button>
                <button 
                  nz-button
                  class="config-position__btn" 
                  [nzType]="config['block_position'] == 'bottom'? 'primary': 'default'" 
                  (click)="handlePositionDrawer('bottom')"
                >
                  <span class="config-position__btn--content">Dưới</span>
                </button>
                <button 
                  nz-button
                  class="config-position__btn" 
                  [nzType]="config['block_position'] == 'left'? 'primary': 'default'" 
                  (click)="handlePositionDrawer('left')"
                >
                  <span class="config-position__btn--content">Trái</span>
                </button>
                <button 
                  nz-button
                  class="config-position__btn" 
                  [nzType]="config['block_position'] == 'right'? 'primary': 'default'" 
                  (click)="handlePositionDrawer('right')"
                >
                  <span class="config-position__btn--content">{{'phai' | translate}}</span>
                </button>
              </div>
            </div>
            <!-- Màu nền -->
          
            <!-- Lớp phủ nền -->
            <div class="config-name">
              <p>{{'lop_phu_nen' | translate}}</p>
              <div>
                <input 
                  class="input-color" type="button"
                  [style.backgroundColor]="class['btn-modal__drawer']?.['background-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['btn-modal__drawer']['background-color']" 
                  (colorPickerClose)="updateClass()" 
                />
              </div>
            </div>
            <!-- Nút tắt (X) -->
            <div class="mt-5 mb-3">
              <p style="font-weight: 500;">{{'nut_tat' | translate}} (X)</p>
  
              <div class="item-symbol">
                <p class="title" style="line-height: 1.5">{{'su_dung' | translate}}</p>
                <nz-switch [(ngModel)]="config.is_show_icon_close" (ngModelChange)="updateConfig()"></nz-switch>
              </div>
  
              <ng-container *ngIf="config.is_show_icon_close">
                <div>
                  <!-- Kích thước icon -->
                  <div class="config-name">
                    <p>{{'kich_thuoc_icon' | translate}}</p>
                    <nz-input-number [nzMin]="1" [nzMax]="50" [nzStep]="1"
                      [ngModel]="class['btn-modal__drawer--icon']['font-size'] | vhnumber" (ngModelChange)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                    [ngModel]="class['btn-modal__drawer--icon']['font-size'] | vhnumber"
                    (ngModelChange)="class['btn-modal__drawer--icon']['font-size'] = $event+'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Màu nút -->
                <div class="config-name">
                  <p>{{'mau_nut' | translate}}</p>
                  <input class="input-color" type="button" [style.background]="class['btn-modal__drawer--icon']['color']"
                    [cpOKButton]="true" [(colorPicker)]="class['btn-modal__drawer--icon']['color']" (colorPickerClose)="updateClass()" />
                </div>
                <!-- Trục X -->
                <div>
                  <div class="config-name">
                    <p>{{'truc_x' | translate}} (%)</p>
                    <nz-input-number [nzMin]="0" [nzMax]="95" [nzStep]="1"
                      [ngModel]="class['btn-modal__drawer--icon']['right'] | vhnumber"
                      (ngModelChange)="class['btn-modal__drawer--icon']['right'] = $event+'%'" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="95" [nzStep]="1"
                    [ngModel]="class['btn-modal__drawer--icon']['right'] | vhnumber"
                    (ngModelChange)="class['btn-modal__drawer--icon']['right'] = $event+'%'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Trục Y -->
                <div>
                  <div class="config-name">
                    <p>{{'truc_y' | translate}} (%)</p>
                    <nz-input-number [nzMin]="0" [nzMax]="95" [nzStep]="1"
                      [ngModel]="class['btn-modal__drawer--icon']['top'] | vhnumber"
                      (ngModelChange)="class['btn-modal__drawer--icon']['top'] = $event+'%'" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="95" [nzStep]="1"
                    [ngModel]="class['btn-modal__drawer--icon']['top'] | vhnumber"
                    (ngModelChange)="class['btn-modal__drawer--icon']['top'] = $event+'%'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <app-choose-animations-config [elementChoosing]="objectChoosing" [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['btn-modal__boundary']" [effect_hover]="effect_hover" [customize]="customize"
          [effectFileUsing]="'button'">
        </app-choose-animations-config>
      </li>
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'kich_thuoc_va_hien_thi' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>
  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!--Cấu hình chi tiết Font chữ -->
    <div class="view_more-text" *ngIf="currentViewAll.index == 1" style="margin-top: 20px">
      <div class="config-text" style="width: 100%">
      </div>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <div class="item-border">
        <p class="m-0 title-border">{{'kieu_vien' | translate}}</p>
        <div class="field-widget" style="display: flex; align-items: center; gap: 3px">
          <button nz-button nz-popover [(nzPopoverVisible)]="isOpenOptionsBorder" style="border: none; background: none"
            nzPopoverTrigger="click" [nzPopoverContent]="contentBorder">
            {{'chon_kieu_vien' | translate}}
          </button>
        </div>
        <ng-template #contentBorder>
          <div class="field-type">
            <div class="field-type-border" title="Solid" [ngClass]="{
                  active: class['btn-modal__boundary']['border-style'] == 'solid'
                }" (click)="
                  class['btn-modal__boundary']['border-style'] = 'solid'; updateClass()
                ">
              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                  fill="#000000" />
              </svg>
            </div>
            <div class="field-type-border" title="Double" [ngClass]="{
                  active: class['btn-modal__boundary']['border-style'] == 'double'
                }" (click)="
                  class['btn-modal__boundary']['border-style'] = 'double'; updateClass()
                ">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-border-style" viewBox="0 0 16 16">
                <path
                  d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
              </svg>
            </div>
            <div class="field-type-border" title="Dashed" [ngClass]="{
                  active: class['btn-modal__popup']['border-style'] == 'dashed'
                }" (click)="
                  class['btn-modal__popup']['border-style'] = 'dashed'; updateClass()
                ">
              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                  fill="#000000" />
              </svg>
            </div>
            <div class="field-type-border" title="Dotted" [ngClass]="{
                  active: class['btn-modal__popup']['border-style'] == 'dotted'
                }" (click)="
                  class['btn-modal__popup']['border-style'] = 'dotted'; updateClass()
                ">
              <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z"
                  fill="#000000" />
              </svg>
            </div>
          </div>
        </ng-template>
      </div>

      <!-- Cấu hình bo tròn -->
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['btn-modal__boundary']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
  <!-- Cấu hình chi tiết hiệu ứng -->
  <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
     <app-animations-config [elementChoosing]="objectChoosing" [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
      [customize]="customize"></app-animations-config>
  </div>
  <!-- Cấu hình chi tiết màu gradient  -->
  <div class="container-gradient" *ngIf="currentViewAll.index == 4 && isViewAll">
    <div class="title-head">
      <p class="text-fill">{{'phoi_mau' | translate}}</p>
      <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
        (ngModelChange)="updateBackgroundRgb()"></label>
    </div>
    <div class="list-gradient">
      <button class="btn-gradient" *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
        [disabled]="!config['background-color'].gradient_check">
        <i class="delete-icon bi bi-x-circle"></i>
      </button>
    </div>
    <p class="title-head mt-4">{{'them_mau' | translate}}</p>
    <div class="container_add-gradient">
      <input class="input-color" type="button" [cpOKButton]="true" [(colorPicker)]="class['btn-modal'].background"
        [disabled]="!config['background-color'].gradient_check" [style.background]="class['btn-modal'].background"
        (colorPickerClose)="addGradient($event)" />
    </div>
    <p class="title-head mt-4">{{'huong_phoi_mau' | translate}}</p>
    <div class="config-name gradient-btn">
      <button class="gradient-direction mr-0" *ngFor="let type of typeGradient" nz-tooltip nzTooltipTitle="{{type.name | translate}}"
        (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check"
        [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [ngClass]="{ 'active': config['background-color'].gradient_direction === type.direction}"></button>
    </div>
  </div>
</div>